import React from 'react';
import { Section } from './ui/Section';
import { Heart } from 'lucide-react';
export function Transformation() {
  const transformations = ['You know exactly what to take and when', 'You stop combining supplements that work against each other', 'You feel more confident about your supplement routine', 'You buy better products with less guesswork', 'You finally use supplements in a way that supports real results'];
  return <Section data-id="element-164">
      <div className="max-w-3xl mx-auto text-center" data-id="element-165">
        <h2 className="text-3xl md:text-5xl font-bold mb-12 text-primary-dark" data-id="element-166">
          Imagine How Much Easier It Will Feel When…
        </h2>

        <div className="space-y-6 mb-16 text-left" data-id="element-167">
          {transformations.map((item, i) => <div key={i} className="flex items-center gap-4 bg-white p-6 rounded-2xl shadow-sm border border-sage-light/20" data-id="element-168">
              <div className="bg-primary/10 p-3 rounded-full text-primary shrink-0" data-id="element-169">
                <Heart size={24} className="fill-primary/20" data-id="element-170" />
              </div>
              <p className="text-xl font-medium text-charcoal/90" data-id="element-171">{item}</p>
            </div>)}
        </div>

        <div className="bg-sage/10 p-10 rounded-3xl border border-sage/20" data-id="element-172">
          <p className="text-2xl font-serif text-primary-dark mb-6" data-id="element-173">
            That’s the goal of the Smart Supplement Guide.
          </p>
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-xl font-bold text-primary" data-id="element-174">
            <span className="line-through opacity-50" data-id="element-175">Not more confusion.</span>
            <span className="line-through opacity-50" data-id="element-176">Not more bottles.</span>
            <span className="text-2xl" data-id="element-177">Just more clarity.</span>
          </div>
        </div>
      </div>
    </Section>;
}